import { arSA } from "../../../../date-fns/locale/ar-SA.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    arSA
  }
};